import { IRichBlockAction } from '@pure1/data';

/**
 * The action list as it renders: the first `primary` keeps its emphasis, every later one is
 * demoted (R2.4, R2.9).
 *
 * Deliberately a client rule and deliberately not in the data layer. "At most one primary" is a
 * relationship *between* items, so no single action is invalid and the server's per-item filter
 * has nothing to drop — which leaves rejecting a whole block over a styling hint, or repairing it.
 * Demoting is the proportionate one, and it is presentation, so it lives beside the renderers.
 *
 * Returns a new list, and a new object only for an action it had to demote: the inputs are
 * payloads the segment list holds, and rewriting one in place would change what copy and export
 * read back.
 */
export function withSinglePrimary(actions: IRichBlockAction[] | undefined): IRichBlockAction[] {
    let primarySeen = false;

    return (actions ?? []).map(action => {
        if (action.emphasis !== 'primary') {
            return action;
        }
        if (!primarySeen) {
            primarySeen = true;
            return action;
        }
        const demoted = { ...action };
        delete demoted.emphasis;
        return demoted;
    });
}
